import React from 'react';
import { VerifiedVetIcon } from '@/icons/VerifiedVet';
import { wagwebTheme } from '@/theme/wagwebTheme';
import { Typography } from '../../wag-react/components/Typography';
import { Flex } from '../../wag-react/next-components/Flex';
import { Box, BoxProps } from '../../wag-react/next-components/box';
export type ArticleMetaProps = Omit<BoxProps, 'value'> & {
  author?: string;
  reviewedBy?: string;
  publishedDate?: string;
  editedDate?: string;
};
export const ArticleMeta = ({
  author,
  reviewedBy,
  publishedDate,
  editedDate
}: ArticleMetaProps) => <Flex flexDirection="column" alignItems="flex-start" data-sentry-element="Flex" data-sentry-component="ArticleMeta" data-sentry-source-file="index.tsx">
    <Flex mb={'14px'} flexDirection={['column', 'row']} alignItems={['flex-start', 'flex-end']} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      {author ? <Typography mr={['0', '17px']} mb={['6px', '0']} mt={0} variant="body2" fontSize="12px" lineHeight="1.5">
          Written By
          {' '}
          <Box as={'b'} style={{
        textTransform: 'capitalize'
      }}>
            {author}
          </Box>
        </Typography> : null}
      <Box data-sentry-element="Box" data-sentry-source-file="index.tsx">
        {publishedDate ? <Typography variant="body2" mr="17px" fontSize="12px" lineHeight="1.5">
            Published:
            {' '}
            {publishedDate}
          </Typography> : null}
        {editedDate ? <Typography variant="body2" my={0} fontSize="12px" lineHeight="1.5">
            Updated:
            {' '}
            {editedDate}
          </Typography> : null}
      </Box>

    </Flex>
    {reviewedBy ? <Flex alignItems="center" py="5px" px="13px" backgroundColor={wagwebTheme.colors.white} borderRadius="40px" alignSelf="flex-start" mr="auto" fontWeight="700" border="0.50px #E8E8E8 solid">
        <Box mr="8px">
          <VerifiedVetIcon height="18px" width="18px" position="relative" top="2px" />
        </Box>

        <Typography variant="body2" my={0} mr="6px" lineHeight="1.5" mt="1px">
          {`Veterinary reviewed by ${reviewedBy}`}
        </Typography>
      </Flex> : null}
  </Flex>;